import BasePage from "@Scripts/Pages/BasePage";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class HomePage extends BasePage {
	public static async init() {
		await super.init();
		this.setTileAnimation();
		this.setHomeAnalytics();
	}

	private static setHomeAnalytics() {
		$('.ga-event[data-ga-id="HighLightLink"]').on("click", function () {
			GTagHelper.sendEvent("click", "highlight", $(this).attr("href"));
		});
	}

	private static setTileAnimation() {
		var interval,
			min = 5000,
			max = 8000;

		function setRandomAnimation() {
			var random = Math.random() * (max - min) + min;

			interval = setInterval(function () {
				addAnimations();
				clearInterval(interval);
				setRandomAnimation();
			}, random);
		}

		function addAnimations() {
			var items = $(".tile[data-animete='true']").not(".animate"),
				randomItems = (<any>window)._.sample(items, 2);

			$.each(randomItems, function (index, value) {
				var random = Math.random() * (max - min) + min;

				$(value)
					.delay(random)
					.queue(function (next) {
						$(this).addClass("animate");
						next();
					})
					.delay(6000)
					.queue(function (next) {
						$(this).removeClass("animate");
						next();
					});
			});
		}

		setRandomAnimation();
		addAnimations();

		$(".tile[data-animete='true']").hover(function () {
			$(this).removeClass("animate");
		});
	}
}
